import React from 'react';
import {
  Box,
  Button,
  Grid,
  Paper,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';
import LinkIcon from '@mui/icons-material/Link';
import DeleteSweepIcon from '@mui/icons-material/DeleteSweep';

import {BasicIdCombo} from '../core/BasicIdCombo';

import { IAllocationCostCenter } from './budgetallocation.models';

type Props = {
  costcenters: IAllocationCostCenter[];
  selectedCostCenter: number | null;
  activitySearch: string;
  lineItemSearch: string;
  selectedActivityCount: number;
  selectedLineItemCount: number;
  selectedLinkCount: number;
  loading?: boolean;
  onCostCenterChange: (id: number | null) => void;
  onActivitySearchChange: (value: string) => void;
  onLineItemSearchChange: (value: string) => void;
  onRefresh: () => void;
  onOpenAllocate: () => void;
  onUnmapSelected: () => void;
};

class BudgetAllocationFilterBar extends React.Component<Props> {
  render() {
    const p = this.props;
    const canAllocate = !!p.selectedCostCenter && p.selectedActivityCount > 0 && p.selectedLineItemCount > 0;

    return (
      <Paper elevation={1} sx={{ p: 2, mb: 3 }}>
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          justifyContent="space-between"
          alignItems={{ xs: 'stretch', md: 'center' }}
          spacing={2}
          sx={{ mb: 2 }}
        >
          <Box>
            <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
              Activity Budget Allocation Filters
            </Typography>
            <Typography variant="caption" color="text.secondary">
              Select approved programme activities and map them to budget line items.
            </Typography>
          </Box>

          <Stack direction="row" spacing={1}>
            <Button
              variant="outlined"
              startIcon={<RefreshIcon />}
              onClick={p.onRefresh}
              disabled={p.loading}
            >
              Refresh
            </Button>

            <Button
              variant="outlined"
              color="error"
              startIcon={<DeleteSweepIcon />}
              onClick={p.onUnmapSelected}
              disabled={p.loading || p.selectedLinkCount === 0}
            >
              Unmap Selected
            </Button>

            <Button
              variant="contained"
              startIcon={<LinkIcon />}
              onClick={p.onOpenAllocate}
              disabled={p.loading || !canAllocate}
            >
              Allocate
            </Button>
          </Stack>
        </Stack>

        <Grid container spacing={2}>
          <Grid size={{ xs: 12, md: 3 }}>
            <BasicIdCombo
              label="Cost Center"
              items={p.costcenters || []}
              value={p.selectedCostCenter}
              onChange={(e:any) => p.onCostCenterChange(e)}
              disabled={p.loading}
            />
          </Grid>

          <Grid size={{ xs: 12, md: 4 }}>
            <TextField
              size="small"
              label="Search Activities"
              value={p.activitySearch || ''}
              onChange={(e) => p.onActivitySearchChange(e.target.value)}
              disabled={p.loading}
              fullWidth
            />
          </Grid>

          <Grid size={{ xs: 12, md: 4 }}>
            <TextField
              size="small"
              label="Search Budget Line Items"
              value={p.lineItemSearch || ''}
              onChange={(e) => p.onLineItemSearchChange(e.target.value)}
              disabled={p.loading}
              fullWidth
            />
          </Grid>
        </Grid>
      </Paper>
    );
  }
}

export default BudgetAllocationFilterBar;
